var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      staticStyle: { width: "100%" },
      model: {
        value: _vm.isFormValid,
        callback: function ($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid",
      },
    },
    [
      _c(
        "v-container",
        {
          staticStyle: { width: "100%" },
          attrs: { "grid-list-md": "", "pa-5": "" },
        },
        [
          _c(
            "v-layout",
            { attrs: { "mb-2": "", wrap: "" } },
            [
              _vm.isUpdating
                ? _c("v-text-field", {
                    attrs: {
                      label: "Service Id (GUID)",
                      disabled: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.empty,
                        _vm.rules.guid,
                      ],
                    },
                    model: {
                      value: _vm.serviceObject.Id,
                      callback: function ($$v) {
                        _vm.$set(_vm.serviceObject, "Id", $$v)
                      },
                      expression: "serviceObject.Id",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "mb-2": "", wrap: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  disabled: _vm.isValidating,
                  rules: [_vm.rules.required, _vm.rules.empty],
                  placeholder: "http://www.xyz.com",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _vm._v("\n          Base Url\n          "),
                        _c("RequiredStar"),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.serviceObject.BaseUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.serviceObject, "BaseUrl", $$v)
                  },
                  expression: "serviceObject.BaseUrl",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              label: "Display Name",
              disabled: _vm.isValidating,
              placeholder: _vm.displayNamePlaceholder,
              "persistent-hint": "",
            },
            model: {
              value: _vm.serviceObject.DisplayName,
              callback: function ($$v) {
                _vm.$set(_vm.serviceObject, "DisplayName", $$v)
              },
              expression: "serviceObject.DisplayName",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              label: "Capabilities URL",
              disabled: _vm.isValidating,
              placeholder: _vm.capabilitiesPlaceholder,
              "persistent-hint": "",
            },
            model: {
              value: _vm.serviceObject.CapabilitiesUrl,
              callback: function ($$v) {
                _vm.$set(_vm.serviceObject, "CapabilitiesUrl", $$v)
              },
              expression: "serviceObject.CapabilitiesUrl",
            },
          }),
          _vm._v(" "),
          _c("v-select", {
            attrs: {
              label: "Service Link",
              disabled: _vm.isValidating,
              items: _vm.serviceLinks,
              "item-text": "ServiceLink",
              "item-value": "Id",
              "persistent-hint": "",
            },
            model: {
              value: _vm.serviceObject.LinkedServiceId,
              callback: function ($$v) {
                _vm.$set(_vm.serviceObject, "LinkedServiceId", $$v)
              },
              expression: "serviceObject.LinkedServiceId",
            },
          }),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { wrap: "", "mt-5": "" } },
            [
              _c(
                "v-btn",
                {
                  staticStyle: { margin: "0 auto" },
                  attrs: { loading: _vm.isValidating },
                  on: {
                    click: function ($event) {
                      return _vm.validate()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.ValidateService")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-chip",
                {
                  staticStyle: { margin: "0 auto", "margin-top": "15px" },
                  attrs: { color: _vm.labelColor, "text-color": "white" },
                },
                [
                  _c(
                    "v-avatar",
                    [
                      _vm.isValidated
                        ? _c("v-icon", [_vm._v("check_circle")])
                        : _c("v-icon", [_vm._v("error_outline")]),
                    ],
                    1
                  ),
                  _vm._v("\n        " + _vm._s(_vm.labelMessage) + "\n      "),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-layout", { attrs: { wrap: "" } }, [
            _c(
              "p",
              { staticStyle: { margin: "0 auto", "margin-top": "10px" } },
              [_vm._v(" " + _vm._s(_vm.validationMessage) + " ")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }